import {
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ImageInput,
  ImageField,
  LongTextInput,
  DateInput,
  FileInput,
  FileField

} from "react-admin";
import React from "react";
import { required } from "../../services/validate";
import { SUPERADMIN } from "../../constant/TypeRole";
const LineForm = props => {
  const { record } = props;

  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <SimpleForm {...props}>
      <ReferenceInput
        disabled={record.project ? true : false}
        validate={[required()]}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="key" validate={[required()]} fullWidth />
    </SimpleForm>
  );
};

export default LineForm;



// WEBPACK FOOTER //
// ./src/components/line/LineForm.js